import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { TalkingPointsContext } from '..';
import { COLOR_GREY_DARK } from '../../colors';
import { skins } from '../skins';
const { magenta } = skins;
const {
    LR_LOGO_PATH,
    EQUAL_HOUSING_LOGO_PATH,
} = magenta;
const COPYRIGHT_YEAR = new Date().getFullYear();

const useStyles = makeStyles(()=> ({
    container: {
        position: 'relative',
        width: '100%',
        height: '100%',
        fontSize: '28px',
    },
    buttonContainer: {
        position: 'absolute',
        left: 166,
        top: 278,
    },
    customButton: {
        background: '#1EC8E1',
        color: '#FFFFFF',
        width: '322px',
        height: '68px',
        borderRadius: '8px',
        borderColor: 'transparent',
        fontSize: '28px',
        fontWeight: '700',
        lineHeight: '20px',
        textAlign: 'center',
        boxShadow: '8px 8px rgba(0, 0, 0, 0.25)',
    },
    userProfileContainer: {
        position: 'absolute',
        left: 58,
        bottom: 100,
        maxWidth: 500,
        fontWeight: 600,
        display: 'flex',
        gap: '16px',
        alignItems: 'flex-start',
        textAlign: 'left',
    },
    userName: {
        fontWeight: 900,
    },
    headshot: {
        minWidth: 122,
        height: 122,
        borderRadius: '50%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    },
    dateContainer: {
        position: 'absolute',
        top: 80,
        right: 142,
        textAlign: 'right',
        fontWeight: 600,
    },
    imageWrap: {
        position: 'absolute',
        width: 260,
        height: 160,
        overflow: 'hidden',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        boxShadow: '4px 4px 4px rgba(0, 0, 0, 0.25)',
        backgroundColor: COLOR_GREY_DARK,
    },
    image0: {
        right: 40,
        bottom: 170,
    },
    image1: {
        right: 76,
        bottom: 90,
    },
    image2: {
        right: 26,
        bottom: 32,
    },
    disclaimer: {
        fontFamily: ['"LL Circular Pro"', 'Arial', 'Helvetica', 'sans-serif'],
        position: 'absolute',
        left: 72,
        bottom: 24,
        textAlign: 'left',
        fontSize: '14px',
        lineHeight: '20px',
    },
    equalHousingLogo: {
        marginLeft: 12,
    },
    disclaimerCopyright: {
        marginTop: 4,
    }
}));

export const Magenta = ()=> {
    const {
        user: {
            name,
            headshot,
        } = {},
        images,
        dateStr,
    } = useContext(TalkingPointsContext);
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div className={classes.dateContainer}>
                {dateStr}
            </div>
            <div className={classes.buttonContainer}>
                <button className={classes.customButton}>See the full report</button>
            </div>
            <div className={classes.userProfileContainer}>
                {headshot && (
                    <div className={classes.headshot}
                        style={{backgroundImage: `url("${headshot}")`}}
                    ></div>
                )}

                {name && (
                    <div className={classes.userProfileName}>
                        Brought to you by<br/>
                        <div className={classes.userName}>{name}</div>
                    </div>
                )}
            </div>

            {(images.length > 2 && images[2]?.length) && (<div className={`${classes.imageWrap} ${classes.image2}`} style={{
                backgroundImage: `url("${images[2]}")`,
            }}></div>)}

            {(images.length > 1 && images[1]?.length) && (<div className={`${classes.imageWrap} ${classes.image1}`} style={{
                backgroundImage: `url("${images[1]}")`,
            }}></div>)}

            {(images.length > 0 && images[0]?.length) && (<div className={`${classes.imageWrap} ${classes.image0}`} style={{
                backgroundImage: `url("${images[0]}")`,
            }}></div>)}

            <div className={classes.disclaimer}>
                <div>
                    <img src={LR_LOGO_PATH} height={14} alt="ListReports" />
                    <img className={classes.equalHousingLogo} src={EQUAL_HOUSING_LOGO_PATH} height={17} alt="Equal Housing Opportunity" />
                </div>
                <div className={classes.disclaimerCopyright}>
                    &copy; ListReports {COPYRIGHT_YEAR}, all rights reserved.
                </div>
            </div>
        </div>
    );
};
